import axios from "axios";
import { cryptoUtil } from "./CryptoUtil";
import { getCurrentEnvironment } from "./Environments";
import { clearAllStorage, getSessionCryptofacil } from "./StorageUtils";

const handle = {
    request: (data, config) => {
        let payload = { ...data };
        if (getCurrentEnvironment().encodedCryptofacil) {
            payload = cryptoUtil.encode(payload)
            config.headers['content-type'] = "text/plain;charset=UTF-8";
        }
        return payload;
    },
    response: (response, config) => config.handleResponse ? config.handleResponse(response, config) : response,
    config: (isRequiered = false) => {
        let session = getSessionCryptofacil();
        return ({
            cryptoUtil: getCurrentEnvironment().encoded ? cryptoUtil : undefined,
            redirectCodes: [500, 510, 401, 420],
            headers: {
                Authorization: isRequiered ? session : getCurrentEnvironment().apiKeyCryptofacil,
                "content-type": "application/json"
            },
            handleResponse: handleResponse
        });
    }
};

function parseData(config, payload) {
    try {
        if (payload && payload.idUsr && payload.login) {
            getCurrentEnvironment().encoded = false;
            return payload;
        }
        return JSON.parse(config.cryptoUtil.decode(payload));
    } catch (e) {
        return payload
    }
}

export function handleResponse(response, config) {
    let data = response.data;

    if (data.headerStatus.code === 200) {
        if (config.cryptoUtil) {
            return parseData(config, data.data);
        } else {
            return data.data;
        }

    }
    //on error
    let error = "";
    //indicate redirect codes [603,604,303...]
    if (config.redirectCodes && config.redirectCodes.length && config.redirectCodes.includes(data.headerStatus.code)) {
        clearAllStorage()
        window.location.pathname = "/"
        config.history.replace("/");
        throw new Error("session_expired")
    } else {
        error = data.message || data.headerStatus.description;
        console.error(error)
        throw new Error(error);
    }
}

const axiosApiCryptofacil = axios.create({
    baseURL: getCurrentEnvironment().cryptoMainUrlV1,
    timeout: 30000,
});

axiosApiCryptofacil.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
);


const ApiCryptofacil = {
    get: async (url, params, isRequiered) => {
        let config = handle.config(isRequiered);
        config.params = { ...params }
        return await axiosApiCryptofacil.get(url, config).then(response => handle.response(response, config))
    },
    getLang: async (url, params) => {
        let config = handle.config();
        config = { ...params }
        return await axiosApiCryptofacil.get(url, config).then(response => handle.response(response, config))
    },
    post: async (url, data, isRequiered) => {
        let config = handle.config(isRequiered);
        return await axiosApiCryptofacil.post(url, handle.request(data, config), config).then(response => handle.response(response, config))
    },
    put: async (url, data, isRequiered) => {
        let config = handle.config(isRequiered);
        return await axiosApiCryptofacil.put(url, handle.request(data, config), config).then(response => handle.response(response, config))
    }
};

export const ServicesCryptofacil = {
    signup: (data) => ApiCryptofacil.post("/Users", data),
    login: (email) => ApiCryptofacil.post("/Login", { email, deviceName: "cryptofacil platform" }),
    loginConfirmationCode: ((code, email) => ApiCryptofacil.post(`/Login/Confirmation/${code}`, { email })),
    getCryptoSubAccount: ((platform) => ApiCryptofacil.get(`/Crypto/getCryptoSubAccount/${platform}`, null, true)),
    setZinliDataAcc: (({ email, phone, idUsr }) => ApiCryptofacil.put(`/Users/Zinli/${idUsr}`, { email, phone }, true)),
    getCryptoCoinsAsync: ((platform) => ApiCryptofacil.get(`/Crypto/coins/${platform}`, null, true)),
    getCryptoNetworksAsync: ((platform, coin) => ApiCryptofacil.get(`/Crypto/networks/${platform}`, { conditional: `coin::${coin}` }, true)),
    getCryptoConversionAsync: ((platform, coin, amount) => ApiCryptofacil.get(`/Crypto/coinConversion/${platform}`, { conditional: `coin::${coin}|amount::${amount}` }, true)),
    getCryptoAddressAsync: ((platform, coin, network) => ApiCryptofacil.get(`/Crypto/address/${platform}`, { conditional: `coin::${coin}|network::${network}` }, true)),
    getEstimateCostAsync: ((platform, amount) => ApiCryptofacil.get(`/Crypto/estimateCost/${platform}`, { conditional: `amount::${amount}` }, true)),
}